import { useEffect, useState } from 'react';
import { SCAN_PAIRS } from '../../data/siteData';
import { prefersReducedMotion, useInViewOnce } from '../../hooks/useMotion';

export const BeforeAfter = () => {
  const [pairKey, setPairKey] = useState('scan');
  const [x, setX] = useState(50);
  const [ref, inView] = useInViewOnce(0.5);
  const pair = SCAN_PAIRS[pairKey];

  // A short wiggle the first time the slider comes into view hints that it can be dragged.
  useEffect(() => {
    if (!inView || prefersReducedMotion()) return undefined;
    let frame;
    let start;
    const step = (t) => {
      if (!start) start = t;
      const k = Math.min(1, (t - start) / 1600);
      setX(50 + Math.sin(k * Math.PI * 2) * 22 * (1 - k));
      if (k < 1) frame = requestAnimationFrame(step);
    };
    frame = requestAnimationFrame(step);
    return () => cancelAnimationFrame(frame);
  }, [inView]);

  return (
    <div className="ba-wrap" data-testid="scan-to-bim">
      <div className="hd">
        <div className="mono">Scan to BIM</div>
        <h2>From existing conditions to a coordinated Revit model</h2>
        <p>
          Scan-to-BIM workflows support renovation, documentation and coordinated design updates for existing
          facilities. Drag the slider to compare.
        </p>
        <div className="seg" role="group" aria-label="Comparison">
          {Object.entries(SCAN_PAIRS).map(([key, p]) => (
            <button
              key={key}
              type="button"
              aria-pressed={pairKey === key}
              onClick={() => {
                setPairKey(key);
                setX(50);
              }}
            >
              {p.label}
            </button>
          ))}
        </div>
      </div>
      <div className="ba" ref={ref} style={{ '--x': `${x}%` }}>
        <img src={pair.after} alt={pair.afterLabel} />
        <img className="top" src={pair.before} alt={pair.beforeLabel} />
        <span className="lab l">{pair.beforeLabel}</span>
        <span className="lab r">{pair.afterLabel}</span>
        <div className="handle"><i>⟷</i></div>
        <input
          type="range"
          min="0"
          max="100"
          value={Math.round(x)}
          onChange={(e) => setX(Number(e.target.value))}
          aria-label={`Compare ${pair.beforeLabel} with ${pair.afterLabel}`}
        />
      </div>
    </div>
  );
};

export default BeforeAfter;
